import { useCallback, useState } from "react";
import { useConfig } from "./useConfig";
import { PrizeDto } from "../models/Lottery";
import { useSnackbar } from "notistack";

export const useDraw = () => {
  const [loading, setLoading] = useState(false);
  const [winningPrizes, setWinningPrizes] = useState<PrizeDto[]>([]);
  const { config } = useConfig();
  const { enqueueSnackbar } = useSnackbar();

  const runDraw = useCallback(
    async (sessionId: string, count: number) => {
      try {
        setLoading(true);

        const res = await fetch(
          `${config.apiUrl}/lottery/session/${sessionId}/draw/${count}`,
          {
            method: "Post",
          }
        );

        if (!res.ok) {
          throw new Error(`Request failed with status ${res.status}`);
        }
        const json = (await res.json()) as PrizeDto[];
        setWinningPrizes(json);
      } catch (err) {
        enqueueSnackbar(`${err}`, {
          variant: "error",
          autoHideDuration: 4000,
        });
      } finally {
        setLoading(false);
      }
    },
    [config.apiUrl, enqueueSnackbar]
  );

  return { runDraw, loading, winningPrizes };
};
